import styled from "styled-components";
import Threshold from "constants/threshold";

export const LecturesLibraryContainer = styled.div`
  position: relative;
`;

export const BlockTitle = styled.h2`
    margin: 40px 0;
    font-size: 20px;
    line-height: 25px;
    font-weight: bold;
    text-align: center;
    
    @media (min-width: ${Threshold.phone}) {
        margin: 57px 0;
        font-size: 35px;
    }
`;

export const Courses = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    width: 96%;
    max-width: 1440px;
    margin: auto;
    
    @media (min-width: ${Threshold.tablet}) {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        width: 74%;
    }
`;

export const BackgroundFigure = styled.img`
    display: none;
    position: absolute;
    z-index: -1;
    width: 47%;
    bottom: 0;
    max-width: 700px;
        
    @media (min-width: ${Threshold.phone}) {
        display: block;
        font-weight: 500;
        font-size: 16px;
        line-height: 35px;
    }
`;
